// src/pages/DanhGiaCuoiKy/DanhGiaCuoiKyMobile.js
import React from "react";
import { XEP_LOAI_COLORS, XEP_LOAI_LABELS } from "./constants";

const DanhGiaCuoiKyMobile = ({ filteredHS, danhGiaMap, onSelect }) => {
  if (filteredHS.length === 0) {
    return <div className="text-center py-12 text-on-surface-variant"><span className="material-symbols-outlined text-[48px]">inbox</span><p>Không có học sinh</p></div>;
  }

  return (
    <div className="space-y-2">
      {filteredHS.map((hs, idx) => {
        const dg = danhGiaMap[hs.id];
        const isDone = dg?.trangThai === 'daHoanThanh';
        return (
          <div key={hs.id} onClick={() => onSelect(hs)}
            className={`bg-surface-container-lowest rounded-xl p-4 shadow-sm border cursor-pointer active:scale-[0.98] transition-transform ${
              isDone ? 'border-green-200' : 'border-outline-variant'
            }`}>
            <div className="flex items-center gap-3">
              <span className="text-caption text-on-surface-variant w-6">{idx + 1}</span>
              <div className="w-10 h-10 rounded-full bg-primary-container text-on-primary-container flex items-center justify-center font-bold">{hs.hoTen?.charAt(0)}</div>
              <div className="flex-1 min-w-0">
                <p className="text-body-md font-semibold truncate">{hs.tenThanh ? `${hs.tenThanh} - ` : ''}{hs.hoTen}</p>
                {dg && (
                  <div className="flex flex-wrap gap-1 mt-0.5">
                    {dg.goiYXepLoai && <span className="px-2 py-0.5 rounded-full text-label-caps" style={{background: XEP_LOAI_COLORS[dg.goiYXepLoai]?.bg, color: XEP_LOAI_COLORS[dg.goiYXepLoai]?.text}}>💡 {XEP_LOAI_LABELS[dg.goiYXepLoai]}</span>}
                    {dg.diemTB > 0 && <span className="text-caption">ĐTB: {dg.diemTB}</span>}
                    <span className="text-caption">CC: {dg.chuyenCan}%</span>
                  </div>
                )}
              </div>
              <span className="text-xl">{isDone ? '✅' : '→'}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DanhGiaCuoiKyMobile;